import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import {getWebComponentInstance} from "fg-frontend/src/webComponents/decorate";

const fragments = {
	NUMBER_OF_DAYS: '[data-fragment="EntitlementContainer.numberOfDays"]',
	STATE_LOCK_LINK: '[data-fragment="EntitlementContainer.stateLockLink"]',
};

class EntitlementContainer extends WebComponent {
	constructor(props) {
		super(props);
		const {} = props;
	}

	didMount() {
		const universalPreloaderComponentElement = document.getElementById('universalPreloader');
		this.universalPreloaderComponent = getWebComponentInstance(universalPreloaderComponentElement);

		const jsonMessagesComponentElement = document.getElementById('jsonMessages');
		this.jsonMessagesComponent = getWebComponentInstance(jsonMessagesComponentElement);

		this.on('change', fragments.NUMBER_OF_DAYS, this.handleChangeNumberOfDaysInput);
		this.on('click', fragments.STATE_LOCK_LINK, this.handleClickOnStateLockLink);

		this.elementBranchId = document.querySelector('[name="frm.branchId"]');
		this.elementMonth = document.querySelector('[name="frm.month"]');
		this.elementYear = document.querySelector('[name="frm.year"]');

		this.initValueInContainer();
	}

	initValueInContainer = () => {
		this.element.querySelector('#stateLockLink').classList.add('hidden');
		let rowElementWithoutId = this.element.querySelectorAll('tr[data-id=""]');
		for(let i = 0;i < rowElementWithoutId.length;i++){
			rowElementWithoutId[i].querySelector('[data-fragment="EntitlementContainer.stateLockLink"]').classList.add('hidden');
			rowElementWithoutId[i].querySelector('.table__action-column a').classList.add('hidden');
		}
	}

	handleChangeNumberOfDaysInput = (e) => {
		this.commitChanges(e);
	}

	commitChanges = (e) => {
		this.universalPreloaderComponent.handleOn(10);
		let dataJSON = [];
		let commitUrl = '/canteen/canteenEntitlement?formId=' + this.getFormId() + '&eventName.storeEmployeeEntitlement';
		let xmlHttpReq = new XMLHttpRequest();
		let _self = this;

		let idValue = e.target.parentElement.parentElement.getAttribute('data-id');
		let employeeIdValue = e.target.parentElement.parentElement.getAttribute('data-employee-id');
		let branchIdValue = this.elementBranchId.options[this.elementBranchId.selectedIndex].getAttribute('value');
		let numberOfDaysValue = e.target.value;
		let yearValue = this.elementYear.value;
		let monthValue = this.elementMonth.value;

		if(employeeIdValue !== ''){

			dataJSON = {
				id: idValue,
				employeeId: employeeIdValue,
				branchId: branchIdValue,
				numberOfDays: numberOfDaysValue,
				year: yearValue,
				month: monthValue,
			};
			xmlHttpReq.open('POST', commitUrl, true);
			xmlHttpReq.setRequestHeader("Content-Type", "application/json");
			xmlHttpReq.onreadystatechange = function () {
				if (xmlHttpReq.readyState === 4) {
					if (xmlHttpReq.status === 200) {
						let data = JSON.parse(xmlHttpReq.responseText);
						if (data.ok) {
							_self.updateDataFromJSON(data.data);
						} else {
							_self.jsonMessagesComponent.showAlert('danger', 'Chyba aplikácie');
						}
						if(data.error) {
							_self.jsonMessagesComponent.showAlert('danger', data.errorMessage);
						}
					}
				}
				_self.universalPreloaderComponent.handleOff(10);
			};
			xmlHttpReq.send(JSON.stringify(dataJSON));
		}

	}

	updateDataFromJSON = (data) => {
		let rowElement = this.element.querySelector('tr[data-employee-id="'+ data.employeeId +'"]');
		let stateLockLinkElement = rowElement.querySelector('[data-fragment="EntitlementContainer.stateLockLink"]');
		let tableActionColumnElement = rowElement.querySelector('.table__action-column a');


		if(rowElement.getAttribute('data-id') === '') {
			rowElement.setAttribute('data-id', data.id);
			stateLockLinkElement.classList.remove('hidden');
			tableActionColumnElement.classList.remove('hidden');

			/* change entitlemendIf in link*/
			const actionElementDataHref = tableActionColumnElement.getAttribute('href');
			const actionElementDataEspTarget = tableActionColumnElement.getAttribute('data-esp-target');
			tableActionColumnElement.setAttribute('href', actionElementDataHref.replace('entitlementId=', `entitlementId=${data.id}`));
			tableActionColumnElement.setAttribute('data-esp-target', actionElementDataEspTarget.replace('entitlementId=', `entitlementId=${data.id}`));
		}
		if(rowElement){
			rowElement.querySelector('[data-fragment="EntitlementContainer.employersContribution"]').innerText = data.employersContribution + ' €';
			rowElement.querySelector('[data-fragment="EntitlementContainer.employeesContribution"]').innerText = data.employeesContribution + ' €';
			rowElement.querySelector('[data-fragment="EntitlementContainer.socialFundContribution"]').innerText = data.socialFundContribution + ' €';
			rowElement.querySelector('[data-fragment="EntitlementContainer.beyondMealUnit"]').innerText = data.beyondMealUnit + ' €';
			let allEntitlementsValidValue = '<span class="text-green">OK</span>';
			if(!data.allEntitlementsValid) {
				allEntitlementsValidValue = '<span class="text-red">NAD NÁROK</span>';
			}
			let stateLockLinkSVG = stateLockLinkElement.children[0].children[0];
			let svgIconDef = '#lock';
			if(data.closed){
				stateLockLinkSVG.setAttributeNS("http://www.w3.org/1999/xlink","xlink:href", svgIconDef);
			} else {
				svgIconDef = '#unlock';
			}
			stateLockLinkSVG.setAttributeNS("http://www.w3.org/1999/xlink","xlink:href", svgIconDef);
			rowElement.querySelector('[data-fragment="EntitlementContainer.allEntitlementsValid"]').innerHTML = allEntitlementsValidValue;
		}
	}

	handleClickOnStateLockLink = (e) => {
		e.preventDefault();

		this.universalPreloaderComponent.handleOn(10);
		let dataJSON = [];
		let commitUrl = '/canteen/canteenEntitlement?formId=' + this.getFormId() + '&eventName.changeEmployeeEntitlementState';
		let xmlHttpReq = new XMLHttpRequest();
		let _self = this;

		let closedValue = false;
		let idValue = e.target.parentElement.parentElement.getAttribute('data-id');
		if(e.target.getAttribute('data-state') === "false"){
			closedValue = true;
		}

		if(idValue !== ''){
			dataJSON = {
				entitlementId: parseInt(idValue),
				closed: closedValue,
			};
			xmlHttpReq.open('POST', commitUrl, true);
			xmlHttpReq.setRequestHeader("Content-Type", "application/json");
			xmlHttpReq.onreadystatechange = function () {
				if (xmlHttpReq.readyState === 4) {
					if (xmlHttpReq.status === 200) {
						let data = JSON.parse(xmlHttpReq.responseText);
						if (data.ok) {
							e.target.setAttribute('data-state', closedValue);
							let svgIconDef = '#lock';
							if(!closedValue) {
								svgIconDef = '#unlock';
							}
							e.target.children[0].children[0].setAttributeNS("http://www.w3.org/1999/xlink","xlink:href", svgIconDef);
						}
						if(data.error) {
							_self.jsonMessagesComponent.showAlert('danger', data.errorMessage);
						}
					}
				}
				_self.universalPreloaderComponent.handleOff(10);
			};
			xmlHttpReq.send(JSON.stringify(dataJSON));
		}
	}

	getFormId = () => {
		return document.querySelector('form[id$=entitlementForm] input[name=formId]').value;
	};
}

export default EntitlementContainer;



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/Canteen/EntitlementContainer.js